module.exports = "<div class=\"drag-and-drop\">\n  <data-ng-transclude class=\"drag-and-drop-content\"\n                      ng-class=\"{ 'drag-and-drop-area' : dndSupport.areaVisible(),\n                                  'drag-active' : dndSupport.dragActive }\">\n  </data-ng-transclude>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/components/drag-and-drop/drag-and-drop.tpl.html
// module id = fmrt
// module chunks = 1